const RENTALS_ACCOMMODATION = {
  //getObjectsTypes
  RENTALS_OBJECT_TYPES: 'RENTALS_OBJECT_TYPES',
  //getObjectsCategories
  RENTALS_OBJECT_CATEGORIES: 'RENTALS_OBJECT_CATEGORIES',
  //getObjectsCities
  RENTALS_OBJECT_CITIES: 'RENTALS_OBJECT_CITIES',
  //getImagesTags
  RENTALS_IMAGES_TAGS: 'RENTALS_IMAGES_TAGS',
  //getUnitMeasures
  RENTALS_UNIT_MEASURES: 'RENTALS_UNIT_MEASURES',
  //getResidentialTaxes
  RENTALS_RESIDENTIAL_TAXES: 'RENTALS_RESIDENTIAL_TAXES',
  //getDiscountApplyPriceTypes
  RENTALS_DISCOUNT_APPLY_PRICE_TYPES: 'RENTALS_DISCOUNT_APPLY_PRICE_TYPES',
  //getDiscountFeeTypes
  RENTALS_DISCOUNT_FEE_TYPES: 'RENTALS_DISCOUNT_FEE_TYPES',
  //getDiscountPackages
  RENTALS_DISCOUNT_PACKAGES: 'RENTALS_DISCOUNT_PACKAGES',
  //getUnitsTypes
  RENTALS_UNITS_TYPES: 'RENTALS_UNITS_TYPES',
  //getServices
  RENTALS_SERVICES: 'RENTALS_SERVICES',
  //getRoomsTypes
  RENTALS_ROOMS_TYPES: 'RENTALS_ROOMS_TYPES',
  //getAllProperties
  RENTALS_ALL_PROPERTIES: 'RENTALS_ALL_PROPERTIES',
  //getPropertiesBasicInfo
  RENTALS_PROPERTIES_BASIC_INFO: 'RENTALS_PROPERTIES_BASIC_INFO',
  //getCountries
  RENTALS_COUNTRIES: 'RENTALS_COUNTRIES',
  //getCountriesFromRoot
  RENTALS_COUNTRIES_FROM_ROOT: 'RENTALS_COUNTRIES_FROM_ROOT',
  //getAllUnits
  RENTALS_ALL_UNITS: 'RENTALS_ALL_UNITS',
  //getCalculationStatusTypes
  RENTALS_CALCULATION_STATUS_TYPE: 'RENTALS_CALCULATION_STATUS_TYPE',
  //getRootCalculationStatusTypes
  RENTALS_ROOT_CALCULATION_STATUS_TYPES: 'RENTALS_ROOT_CALCULATION_STATUS_TYPES',
  //getCurrencies
  RENTALS_ACCOMMODATION_CURRENCIES: 'RENTALS_ACCOMMODATION_CURRENCIES',
  //getLanguages
  RENTALS_LANGUAGES: 'RENTALS_LANGUAGES',
  //getLanguagesFromRoot
  RENTALS_LANGUAGES_FROM_ROOT: 'RENTALS_LANGUAGES_FROM_ROOT',
  //getCities
  RENTALS_CITIES: 'RENTALS_CITIES',
  //getOffices
  RENTALS_OFFICES: 'RENTALS_OFFICES',
  RENTALS_OFFICE_DETAILS: 'RENTALS_OFFICE_DETAILS',
  //get cooperation types
  RENTALS_COOPERATION_TYPES: 'RENTALS_COOPERATION_TYPES',
  //get accommodation units
  RENTALS_ACCOMMODATION_UNITS: 'RENTALS_ACCOMMODATION_UNITS',

  RENTALS_CALCULATION_LOGS: 'RENTALS_CALCULATION_LOGS',
  RENTALS_CALCULATION_LOG_TYPES: 'RENTALS_CALCULATION_LOG_TYPES',
  RENTALS_CALCULATION_LOG_DOCUMENT: 'RENTALS_CALCULATION_LOG_DOCUMENT',
  RENTALS_CALCULATION_GUESTS: 'RENTALS_CALCULATION_GUESTS',
  RENTALS_CALCULATION_GUEST_DETAILS: 'RENTALS_CALCULATION_GUEST_DETAILS',
  RENTALS_CALCULATION_SERVICE_TYPE: 'RENTALS_CALCULATION_SERVICE_TYPE',
  RENTALS_CALCULATION_DOCUMENTS: 'RENTALS_CALCULATION_DOCUMENTS',
  RENTALS_CALCULATION_PAYMENTS: 'RENTALS_CALCULATION_PAYMENTS',
  RENTALS_CALCULATION_MAIL_TASKS: 'RENTALS_CALCULATION_MAIL_TASKS',
  RENTALS_CALCULATION_TEMPLATE_DETAILS: 'RENTALS_CALCULATION_TEMPLATE_DETAILS',
  RENTALS_CALCULATION_TEMPLATE_EMAILS: 'RENTALS_CALCULATION_TEMPLATE_EMAILS',
  RENTALS_CALCULATION_MAIL_DETAILS: 'RENTALS_CALCULATION_MAIL_DETAILS',
  RENTALS_CALCULATION_STATEMENTS: 'RENTALS_CALCULATION_STATEMENTS',
  RENTALS_CALCULATION_WORKFLOW_TASKS: 'RENTALS_CALCULATION_WORKFLOW_TASKS',
  RENTALS_ACCOMMODATION_SERVICES: 'RENTALS_ACCOMMODATION_SERVICES',
  RENTALS_ACCOMMODATION_SUPERGROUPS: 'RENTALS_ACCOMMODATION_SUPERGROUPS',
  RENTALS_ACCOMMODATION_COMPANIES_BANK_ACCOUNTS: 'RENTALS_ACCOMMODATION_COMPANIES_BANK_ACCOUNTS',
  RENTALS_ACCOMMODATION_PARTNER_RESERVATION: 'RENTALS_ACCOMMODATION_PARTNER_RESERVATION',
  RENTALS_ACCOMMODATION_PARTNER_CARD_DETAILS: 'RENTALS_ACCOMMODATION_PARTNER_CARD_DETAILS',
  RENTALS_ACCOMMODATION_INVOICES: 'RENTALS_ACCOMMODATION_INVOICES',

  RENTALS_ACCOMMODATION_DESCRIPTIONS_PROPERTY: 'RENTALS_ACCOMMODATION_DESCRIPTIONS_PROPERTY',
  RENTALS_ACCOMMODATION_DESCRIPTIONS_UNIT: 'RENTALS_ACCOMMODATION_DESCRIPTIONS_UNIT',
  RENTALS_DESCRIPTION_TYPES: 'RENTALS_DESCRIPTION_TYPES',

  RENTALS_ACCOMMODATION_LOGS_TYPES: 'RENTALS_ACCOMMODATION_LOGS_TYPES',
  RENTALS_ACCOMMODATION_LOGS: 'RENTALS_ACCOMMODATION_LOGS',

  RENTALS_ACCOMMODATION_COUNTRIES: 'RENTALS_ACCOMMODATION_COUNTRIES',
};

export default RENTALS_ACCOMMODATION;
